import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row } from '@cancercentrum/rcc-bootstrap';
import { useState } from 'react';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { incaAccessor } from '@cancercentrum/inca';
import { useIsReviewer } from '../../../../hooks/useIsReviewer';
import { useErrandPanelContext } from '../../ErrandPanel';
import { errandButtonUtils } from '../../errandButtonUtils';
import { SimplifiedErrandButtonTags } from '../../constants';
import { ReporterSection } from '../../../ReporterSection';
import { ReviewerSection } from '../../../ReviewerSection';
export const SaveInRegistryModal = (props)=>{
    const { onCancel, onSuccess } = props;
    const ctx = useErrandPanelContext();
    const reportingPositionId = ctx.errand.document.reportingPositionId;
    const inca = incaAccessor();
    const positionId = inca.user.position.id;
    const isReportingPosition = positionId === reportingPositionId;
    const isReviewer = useIsReviewer();
    const showSelect = ()=>isReportingPosition || !reportingPositionId;
    const [selectedPositionId, setSelectedPositionId] = useState(showSelect() ? undefined : reportingPositionId);
    const [comment, setComment] = useState(ctx.errandComment);
    const onSubmit = ()=>{
        if (isReviewer) {
            onSuccess('Klar', {
                selectedPositionId: selectedPositionId
            });
            return;
        }
        if (ctx.options.allowReporterToSaveDirectly) {
            onSuccess('Spara_i_register', {});
        } else {
            onSuccess('Skicka_till_RCC_och_delspara', {
                errandTags: errandButtonUtils.getTagsString([
                    SimplifiedErrandButtonTags.Delspara,
                    SimplifiedErrandButtonTags.Inrapporterat
                ], [], [
                    SimplifiedErrandButtonTags.ForGodkannande
                ], ctx),
                comment: comment
            });
        }
    };
    const handleSelectedPositionIdChange = (position)=>{
        setSelectedPositionId(position?.id);
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        show: true,
        onHide: onCancel,
        backdrop: "static",
        bsSize: "xl",
        animation: false,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: /*#__PURE__*/ _jsx("strong", {
                        children: "Vill du spara ner ärendet i registret?"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "Ärendet kommer att sparas i registret"
                    }),
                    /*#__PURE__*/ _jsx(ReporterSection, {
                        children: !ctx.options.allowReporterToSaveDirectly && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: "En kopia av ärendet kommer att gå till RCC i din region."
                                }),
                                /*#__PURE__*/ _jsxs(FormGroup, {
                                    componentClass: Row,
                                    children: [
                                        /*#__PURE__*/ _jsx(ControlLabel, {
                                            column: true,
                                            sm: 2,
                                            children: "Kommentar"
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            sm: 10,
                                            children: /*#__PURE__*/ _jsx(FormControl, {
                                                componentClass: "textarea",
                                                value: comment,
                                                onChange: (e)=>setComment(e.target.value)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(ReviewerSection, {
                        children: /*#__PURE__*/ _jsxs(FormGroup, {
                            className: "mt-2",
                            componentClass: Row,
                            children: [
                                /*#__PURE__*/ _jsx(ControlLabel, {
                                    className: "me-md-3 me-lg-0",
                                    column: true,
                                    sm: 2,
                                    children: "Inrapporterande enhet"
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    sm: 10,
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        options: ctx.reportingPositions,
                                        value: ctx.reportingPositions.find((x)=>x.id === selectedPositionId),
                                        getOptionValue: (x)=>x.id.toString(),
                                        getOptionLabel: (x)=>x.fullNameWithCode,
                                        placeholder: "-- Välj organisationsenhet --",
                                        onChange: (e)=>handleSelectedPositionIdChange(e)
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTimes,
                        onClick: onCancel,
                        bsStyle: "default-2",
                        children: "Avbryt"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: isReviewer && showSelect() && !selectedPositionId,
                        icon: faSave,
                        bsStyle: "primary",
                        className: "mr-2",
                        onClick: onSubmit,
                        children: "Spara i register"
                    })
                ]
            })
        ]
    });
};
